
angular.module('clientDashboardApp').factory('scoreService', function ($http) {
    function ScoreService() {
    }

    ScoreService.prototype.snapshotSummary = function (groupId) {
        return $http.get('/v5/scores/average', {params: {groupId: groupId}}).then(response => response.data)
    };

    return new ScoreService();
});
